var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30.645C23.2843 30.645 30 23.9293 30 15.645C30 7.36073 23.2843 0.644989 15 0.644989C6.71574 0.644989 0 7.36073 0 15.645C0 23.9293 6.71574 30.645 15 30.645ZM15.5483 15.4073L22.2573 10.752C22.0304 10.4445 21.6655 10.245 21.254 10.245H8.74602C8.35008 10.245 7.99728 10.4297 7.76904 10.7175L14.2764 15.3966C14.6554 15.6691 15.1648 15.6733 15.5483 15.4073ZM22.5 19.7463V11.9336L16.04 16.416C15.3565 16.8903 14.4483 16.8827 13.7729 16.397L7.5 11.8866V19.7463C7.5 20.4344 8.05785 20.9923 8.74602 20.9923H21.254C21.9422 20.9923 22.5 20.4344 22.5 19.7463Z",
    fill: "url(#paint0_linear_468_1017)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_1017",
    x1: 3.75,
    y1: 4.39499,
    x2: 26.25,
    y2: 27.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA110"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3146430668248f5d22e8efe165e87a37.svg";
export { ForwardRef as ReactComponent };